<template>
  <div class="premission_index">
    <el-row class="elAdd">
      <button
        type="primary"
        class="add"
        icon="el-icon-plus"
        @click="dialogFormVisible = true"
        >新增</button
      >
      <!-- <div class="search_div">
        <el-input
          v-model="keywords"
          class="search_input"
          size="medium "
          placeholder="请输入搜索内容"
          prefix-icon="el-icon-search"
        />
        <el-button type="primary" @click="getAnnounceList()">搜索</el-button>
      </div> -->
    </el-row>
    <!-- 表格 -->
    <!-- <el-table
      class="premission_table"
      :data="tableData"
      :header-cell-style="{background: '#F9F9F9',color:'#999999'}"
      style="width: 100%"
    >
      <el-table-column type="index" label="序号" width="60" />
      <el-table-column prop="content" label="公告内容" />
      <el-table-column prop="created_at" label="创建时间" width="160" />
      <el-table-column prop="updated_at" label="更新时间" width="160" />
      <el-table-column label="操作" fixed="right" width="160">
        <template slot-scope="scope">
          <el-button type="primary" size="mini" @click="handleEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            plain
            type="danger"
            size="mini"
            @click="handleDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table> -->
    <!-- 展示列表 -->
    <el-tree
      ref="menuTree"
      class="user_tree"
      :data="tableData"
      node-key="id"
      :props="defaultProps"
      :filter-node-method="filterNode"
    >
      <span slot-scope="{ node, data }" class="custom-tree-node">
        <span>{{ node.label }}</span>
        <span class="button_margin">
          <el-button type="text" size="mini" @click.stop="() => edit(data)"
            >编辑</el-button
          >
          <el-button type="text" size="mini" @click.stop="deleteClick(node)"
            >删除</el-button
          >
        </span>
      </span>
    </el-tree>
    <!-- 分页 -->
    <div class="pagination" v-if="totalPage > 10">
      <el-pagination
        background=""
        layout="prev, pager, next"
        :total="totalPage"
        :current-page.sync="currentPage"
        @current-change="getAnnounceList(currentPage)"
      />
    </div>
    <!-- 添加弹框 -->
    <el-dialog
      top="15vh"
      title="新增"
      :visible.sync="dialogFormVisible"
      width="50%"
      :close-on-click-modal="false"
    >
      <el-form :model="form" :rules="rules" ref="form">
        <!-- <el-form-item prop="content" label="公告内容:" :label-width="formLabelWidth">
          <el-input type="textarea" :row="3" placeholder="请输入公告内容" v-model="form.content" autocomplete="off"></el-input>
        </el-form-item> -->
        <el-form-item
          prop="model"
          label="菜单类型:"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="form.model"
            placeholder="请选择菜单类型"
            @change="getMenuLinkageList"
          >
            <el-option label="目录" value="1" />
            <el-option label="菜单" value="2" />
            <el-option label="权限" value="3" />
          </el-select>
          <!-- <el-radio v-model="form.model" :label="1">目录</el-radio>
          <el-radio v-model="form.model" :label="2">菜单</el-radio>
          <el-radio v-model="form.model" :label="3">权限</el-radio> -->
        </el-form-item>
        <el-form-item
          prop="name"
          label="节点名称:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入节点名称"
            v-model="form.name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="pid"
          label="服务名称:"
          :label-width="formLabelWidth"
        >
          <el-row>
            <el-cascader
              :options="options"
              v-model="form.pid"
              :show-all-levels="true"
              clearable
              :props="{
                expandTrigger: 'hover',
                children: 'children',
                label: 'name',
                value: 'id',
                checkStrictly: true,
                emitPath: false,
              }"
              @change="handleChange"
            >
            </el-cascader>
          </el-row>
        </el-form-item>
        <el-form-item
          prop="list"
          label="选择菜单:"
          :label-width="formLabelWidth"
        >
          <el-cascader
            :options="permissionOptions"
            v-model="list"
            :props="propd"
          ></el-cascader>
          <!-- <el-cascader
    :options="permissionOptions"
    :props="propss"
    clearable></el-cascader> -->
        </el-form-item>

        <el-form-item prop="icon" label="图标:" :label-width="formLabelWidth">
          <e-icon-picker v-model="form.icon" />
        </el-form-item>
        <el-form-item
          prop="visible"
          label="是否隐藏:"
          :label-width="formLabelWidth"
        >
          <el-switch
            v-model="form.visible"
            active-text="显示"
            inactive-text="隐藏"
            :active-value="true"
            :inactive-value="false"
          >
          </el-switch>
        </el-form-item>
        <el-form-item
          prop="index"
          label="排序号:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入排序号"
            v-model="form.index"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="url"
          label="路由地址:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入路由地址"
            v-model="form.url"
            autocomplete="off"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item label="成员身份:" :label-width="formLabelWidth" prop="type">
          <el-select v-model="form.grade" placeholder="请选择">
            <el-option label="目录" :value="1"></el-option>
            <el-option label="菜单" :value="2"></el-option>
            <el-option label="权限" :value="3"></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <button class="login_Edit" @click="dialogFormVisible = false">取 消</button>
        <button class="ok_Edit"  type="primary" @click="postForm">确 定</button>
      </div>
    </el-dialog>
    <!-- 编辑弹框 -->
    <el-dialog
      top="15vh"
      title="编辑菜单"
      :visible.sync="dialogFormVisibleEdit"
      width="40%"
      :close-on-click-modal="false"
    >
      <el-form :model="formEdit" :rules="rules" ref="formEdit">
        <!-- <el-form-item prop="content" label="公告内容:" :label-width="formLabelWidth">
          <el-input type="textarea" :row="3" placeholder="请输入公告内容" v-model="formEdit.content" autocomplete="off"></el-input>
        </el-form-item> -->
        <el-form-item
          prop="model"
          label="状态(身份):"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="formEdit.model"
            placeholder="请选择菜单类型"
            @change="getMenuLinkageList"
          >
            <el-option label="目录" value="1" />
            <el-option label="菜单" value="2" />
            <el-option label="权限" value="3" />
          </el-select>
          <!-- <el-radio v-model="formEdit.model" :label="1">目录</el-radio>
          <el-radio v-model="formEdit.model" :label="2">菜单</el-radio>
          <el-radio v-model="formEdit.model" :label="3">权限</el-radio> -->
        </el-form-item>
        <el-form-item
          prop="name"
          label="节点名称:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入节点名称"
            v-model="formEdit.name"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="pid"
          label="服务名称:"
          :label-width="formLabelWidth"
        >
          <el-row>
            <el-cascader
              :options="options"
              v-model="formEdit.pid"
              :show-all-levels="true"
              clearable
              :props="{
                expandTrigger: 'hover',
                children: 'children',
                label: 'name',
                value: 'id',
                checkStrictly: true,
                emitPath: false,
              }"
              @change="handleChange"
            >
            </el-cascader>
          </el-row>
        </el-form-item>
        <el-form-item
          prop="pstlist"
          label="选择菜单:"
          :label-width="formLabelWidth"
        >
          <el-cascader
            :options="permissionOptions"
            v-model="formEditlist"
            :props="propd"
          ></el-cascader>
          <!-- <el-cascader
    :options="permissionOptions"
    :props="propss"
    clearable></el-cascader> -->
        </el-form-item>
        <el-form-item prop="icon" label="图标:" :label-width="formLabelWidth">
          <e-icon-picker v-model="formEdit.icon" />
        </el-form-item>
        <el-form-item
          prop="visible"
          label="是否隐藏:"
          :label-width="formLabelWidth"
        >
          <el-switch
            v-model="formEdit.visible"
            active-text="显示"
            inactive-text="隐藏"
            :active-value="true"
            :inactive-value="false"
          >
          </el-switch>
        </el-form-item>
        <el-form-item
          prop="index"
          label="排序号:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入排序号"
            v-model="formEdit.index"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="url"
          label="路由地址:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入路由地址"
            v-model="formEdit.url"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <button class="login_Edit" @click="dialogFormVisibleEdit = false">取 消</button>
        <button class="ok_Edit" type="primary" @click="postFormEdit">确 定</button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import { addAnnounce, deleteAnnounce, editAnnounce, announceList } from '@/api/shop.js'

export default {
  name: "Premission",
  data() {
    return {
      propd: {
        multiple: true,
        label: "name",
        value: "mark",
      },
      optionss: [
        {
          value: 1,
          label: "东南",
          children: [
            {
              value: 2,
              label: "上海",
              children: [
                { value: 3, label: "普陀" },
                { value: 4, label: "黄埔" },
                { value: 5, label: "徐汇" },
              ],
            },
            {
              value: 7,
              label: "江苏",
              children: [
                { value: 8, label: "南京" },
                { value: 9, label: "苏州" },
                { value: 10, label: "无锡" },
              ],
            },
            {
              value: 12,
              label: "浙江",
              children: [
                { value: 13, label: "杭州" },
                { value: 14, label: "宁波" },
                { value: 15, label: "嘉兴" },
              ],
            },
          ],
        },
        {
          value: 17,
          label: "西北",
          children: [
            {
              value: 18,
              label: "陕西",
              children: [
                { value: 19, label: "西安" },
                { value: 20, label: "延安" },
              ],
            },
            {
              value: 21,
              label: "新疆维吾尔族自治区",
              children: [
                { value: 22, label: "乌鲁木齐" },
                { value: 23, label: "克拉玛依" },
              ],
            },
          ],
        },
      ],
      propss: {
        multiple: true,
        children: "children",
        checkStrictly: true,
        label: "name",
        value: "name",
      },
      isAllSelect: false,
      keys: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      pstlist: "",
      permissionOptions: [],
      checkList: "",
      options: "",
      keywords: "",
      totalPage: 0,
      currentPage: 1,
      tableData: [],
      dialogFormVisible: false,
      dialogFormVisibleEdit: false,
      formLabelWidth: "120px",
      list:'',
      formEditlist:'',
      form: {
        // content:"",
        visible: true,
        index: "",
        url: "",
        // pstlist:'',
        permission: "",
        pid: "",
        icon: "",
        name: "",
        grade: "",
        model: "",
      },
      formEdit: {
        id: "",
        // content:"",
        visible: "",
        index: "",
        permission:'',
        url: "",
        icon: "",
        name: "",
        grade: "",
        model: "",
        pid: "",
        pstlist: "",
      },
      rules: {
        // content:[{ required: true, message: "请输入公告内容", trigger: "blur" }],
        name: [{ required: true, message: "请输入节点名称", trigger: "blur" }],
        model: [
          { required: true, message: "请选择状态(身份)", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getAnnounceList();
    this.getMenuLinkageList();
    this.getPermissionList();
  },
  methods: {
    edit(data) {
      // let { type, id, parent_id, title, icon, path, vue_route, permission } = data
      console.log(data.permission);
      this.dialogFormVisibleEdit = true;
      this.formEdit = data;
      let arr = data.permission.split(',');
      this.formEditlist = arr.map(item => item.split(':'))
      console.log(this.formEditlist);
      // this.formEdit.pstlist = data.permission;
      // console.log(this.formEdit);
      // menuDetail({
      //   sign: '111',
      //   token: sessionStorage.getItem('token'),
      //   id: data.id
      // })
      //   .then(res => {
      //     this.editForm = res.data
      //     this.editForm.sign = '111'
      //     this.editForm.token = sessionStorage.getItem('token')
      //   })
      //   .catch(err => {
      //     console.log(err)
      //   })
      // this.getMenuLinkageList(data.type)
    },
    // getMenuIds() {
    //   // let menuIds = this.$refs.menusTree.getCheckedKeys()
    //   // this.roleForm.permission = menuIds
    //   if (Array.isArray(this.$refs.menusTree.getCheckedKeys())) {
    //     console.log(this.$refs.menusTree.getCheckedKeys());
    //     this.form.permission = this.$refs.menusTree.getCheckedKeys().join();
    //   }
    //   console.log(this.form.permission);
    // },
    deleteClick(val) {
      console.log(val.key);
      depot
        .post({
          url: "/backend/menu/delete",
          data: {
            id: val.key,
          },
        })
        .then((res) => {
          console.log(res);
          if (res.success == true) {
            this.$message({
              message: res.data,
              type: "success",
            });
            this.getMenuLinkageList();
            return;
          }
          this.$message({
            message: res.msg,
            type: "error",
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },
    handleChange() {
      console.log(this.value);
    },
    getMenuLinkageList(value) {
      // console.log(value);
      depot
        .post({
          url: "/backend/menu/getMenus",
          data: {},
        })
        .then((res) => {
          console.log(res);
          this.tableData = res.data;
          console.log(this.tableData);
          this.options = JSON.parse(JSON.stringify(res.data));
          console.log(this.tableData);
          this.options.forEach((val, index) => {
            val.children.forEach((valus, index) => {
              delete valus.children;
            });
            // delete val.children
          });
          console.log(this.options);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPermissionList(value) {
      // console.log(value);
      depot
        .post({
          url: "/backend/menu/getPermission",
          data: {},
        })
        .then((res) => {
          console.log(res);
          this.permissionOptions = res.data;
          console.log(this.permissionOptions);
          this.permissionOptions.forEach((val, index) => {
            val.children.forEach((valus, index) => {
              valus.children.forEach((valthree, index) => {
                valthree.children.forEach((valsi, index) => {
                  if (valsi.children.length == 0) {
                    delete valsi.children;
                  }
                  // delete val.children
                });
              });
            });
            // delete val.children
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getAnnounceList(page = 1, page_num = 10) {
      // announceList({
      //   keywords:this.keywords,
      //   page: page,
      //   page_num: page_num
      // }).then(res => {
      //   this.tableData = res.data.data
      //   this.totalPage = res.data.total
      // }).catch(err => {
      //   console.log(err)
      // })
    },
    postForm() {
      console.log();
      //  this.form.permission.forEach((val, index) => {
      //       console.log(val);
      //       // delete val.children
      // });
      // let str = "";
      // for (var i = 0; i < this.permission.length; i++) {
      //   str += this.permission[i] + "|";
      //   var newlist = str.replace(/\,/g, ":");
      //   this.form.permission = newlist.replace(/\|/g, ",");
      //   // this.form.permission = this.form.permission.substr(0,this.form.permission.length-1);
      //   console.log(this.form.permission);
      // }
      this.form.permission = this.list.map(item => item.join(':')).join(',');
      console.log(this.list.map(item => item.join(':')).join(','));
      console.log(this.form.permission);
      this.$refs["form"].validate((valid) => {
        if (valid) {
          depot
            .post({
              url: "/backend/menu/save",
              data: this.form,
            })
            .then((res) => {
              console.log(res);
              if (res.success == true) {
                this.$message({
                  message: res.data,
                  type: "success",
                });
                this.dialogFormVisible = false;
                this.getMenuLinkageList();
                return;
              }
              this.$message({
                message: '新增失败',
                type: "error",
              });
            })
            .catch((err) => {
              console.log(err);
            });
          // addAnnounce(this.form).then(res => {
          //   this.$message({
          //     message:res.message,
          //     type:"success",
          //     duration:2000
          //   })
          //   this.dialogFormVisible = false;
          //   this.getAnnounceList(this.currentPage);
          //   this.$refs["form"].resetFields();
          // }).catch(err => {
          //   console.log(err)
          // })
        }
      });
    },
    handleDelete(row) {
      this.$confirm("是否确认删除?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAnnounce({
            id: row.id,
          })
            .then((res) => {
              this.getAnnounceList(this.currentPage);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    handleEdit(row) {
      let { id, name, grade, visible, pid, index, url, model, icon } = row;
      this.formEdit.id = id;
      // this.formEdit.content = content
      this.formEdit.name = name;
      this.formEdit.icon = icon;
      this.formEdit.pid = pid;
      // this.formEdit.pstlist = pstlist;
      // this.formEdit.pstlist = permission;
      this.formEdit.visible = visible;
      this.formEdit.index = index;
      this.formEdit.url = url;
      this.formEdit.grade = grade;
      this.formEdit.model = model;
      this.dialogFormVisibleEdit = true;
    },
    postFormEdit() {
      this.formEdit.permission = this.formEditlist.map(item => item.join(':')).join(',');
      console.log(this.formEditlist.map(item => item.join(':')).join(','));
      console.log(this.formEdit.permission);
      this.$refs["formEdit"].validate((valid) => {
        if (valid) {
          depot
            .post({
              url: "/backend/menu/update",
              data: this.formEdit,
            })
            .then((res) => {
              console.log(res);
              if (res.success == true) {
                this.$message({
                  message: '修改成功',
                  type: "success",
                });
                this.dialogFormVisibleEdit = false;
                this.getMenuLinkageList();
                return;
              }
              this.$message({
                message: '修改失败',
                type: "error",
              });
            })
            .catch((err) => {
              console.log(err);
            });
          // editAnnounce(this.formEdit)
          //   .then((res) => {
          //     this.$message({
          //       message: res.message,
          //       type: "success",
          //       duration: 2000,
          //     });
          //     this.dialogFormVisibleEdit = false;
          //     this.getAnnounceList(this.currentPage);
          //     this.$refs["formEdit"].resetFields();
          //   })
          //   .catch((err) => {
          //     console.log(err);
          //   });
        }
      });
    },
  },
};
</script>

<style scoped>
.premission_index {
  padding: 10px;
  background: #fff;
  margin-top: 10px;
}
.search_div {
  float: right;
}
.search_input {
  width: 220px;
}
.premission_table {
  margin-top: 10px;
}
.pagination_box {
}
.pagination {
  padding: 0 300px;
  margin-top: 20px;
  text-align: center;
}
.elAdd {
  margin-bottom: 10px;
}
.add {
  position: fixed;
  right: 20px;
  top:88px;
  font-size: 16px;
  width: 120px;
  font-weight: 400;
  height: 40px;
  background: #009b43;
  border: none;
  color: #fff;
   moz-transition: all .4s ease-in-out;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
    border-radius: 3px;
}

.add:hover {
  border-radius: 3px;
  background-image: linear-gradient(to right, #0ba360, #3cba92, #30dd8a, #2bb673);
  box-shadow: 0 4px 15px 0 rgba(23, 168, 108, 0.75);
   background-position: 100% 0;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
.ok_Edit {
  cursor: pointer;
  width: 120px;
  height: 40px;
  background: #009B43;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
  border: none;
  margin-left: 30px;
  color: #fff;
}
.login_Edit {
  cursor: pointer;
  width: 120px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  background: #EEEEEE;
  border-radius: 4px;
  border: none;
  color: #999999;
}
</style>




// WEBPACK FOOTER //
// src/views/menu/index.vue